<template>
  <div class="header-section">
    <div id="video-container" class="video-container">
      <video
        id="index-video"
        class="index-video"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline="true"
        mtt-playsinline="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portrait"
        disablePictureInPicture
      ></video>
      <div class="slogan"></div>
    </div>
    <div class="top-container" v-if="!isMobile">
      <div class="game-logo"></div>
    </div>
    <div class="center-container">
      <div class="login-module">
        <div v-if="isLogin" class="user-info">
          <div class="info">
            <span class="avatar"></span>
            <span class="username">{{ accountName }}</span>
          </div>
          <div class="logout-btn" @click="logout()">
            {{ langData.logoutBtn }}
          </div>
        </div>
        <div v-else class="login-btn btns" @click="gotoLogin()"></div>
        <div class="feedback-btn btns" @click="showFeedbackPopup"></div>
        <div
          class="participant-count"
          v-html="
            getReplaceText(langData.joinActivityText, participantCount || 0)
          "
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { getReplaceText } from "@/utils";
import LanguageHook from "@/hooks/language";

// 语言相关
const { langData } = LanguageHook();

// 注入的数据
const isLogin = inject("isLogin");
const accountName = inject("accountName");
const isMobile = inject("isMobile");
const participantCount = inject("participantCount", 0);
const checkLogin = inject("checkLogin", () => {});

// Props & Emits
const emit = defineEmits(["gotoLogin", "logout"]);

// 方法
const showFeedbackPopup = () => {
  if (!checkLogin()) return;
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "反馈按钮",
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "反馈弹窗",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  emit("showFeedbackPopup");
};

const gotoLogin = () => {
  emit("gotoLogin");
};

const logout = () => {
  emit("logout");
};
</script>
